import { render, staticRenderFns } from "./alertDialog.vue?vue&type=template&id=cf1dfffe&scoped=true"
import script from "./alertDialog.vue?vue&type=script&lang=js"
export * from "./alertDialog.vue?vue&type=script&lang=js"
import style0 from "./alertDialog.vue?vue&type=style&index=0&id=cf1dfffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1dfffe",
  null
  
)

export default component.exports